import routes from '@/constants/routes';

const navigationList: any = [
	[
		{
			id: 1,
			name: 'Branding',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/services/branding'
		},
		{
			id: 2,
			name: 'Website Production',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/services/web-design'
		},
		{
			id: 3,
			name: 'Creative marketing partnership',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/services/creative-content'
		}
	],
	[
		{
			id: 1,
			name: 'About us',
			url: routes.aboutUs
		},
		{
			id: 2,
			name: 'Services',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/services'
		},
		{
			id: 3,
			name: 'Brand Quiz',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/brandquiz'
		}
	],
	[
		{
			id: 1,
			name: 'Case studies',
			url: routes.caseStudies
		},
		{
			id: 2,
			name: 'Blog',
			url: process.env.NEXT_PUBLIC_LEGACY_URL + '/blog'
		}
	]
];

enum ServiceValue {
	Branding = 'Branding',
	WebsiteProduction = 'Website Production',
	CreativeMarketing = 'Creative Marketing'
}

const servicesList = [
	{
		id: 3,
		value: ServiceValue.Branding,
		label: 'Branding'
	},
	{
		id: 2,
		value: ServiceValue.WebsiteProduction,
		label: 'Website Production'
	},
	{
		id: 1,
		value: ServiceValue.CreativeMarketing,
		label: 'Creative Marketing Partnership'
	}
];

enum BudgetValue {
	Small = '15K - 30K',
	Medium = '30K - 70K',
	Large = 'More than 70K'
}

const budgetList = [
	{ id: 1, value: BudgetValue.Small, label: '$15K—30K', isActive: false },
	{ id: 2, value: BudgetValue.Medium, label: '$30K—70K', isActive: false },
	{ id: 3, value: BudgetValue.Large, label: 'More than $70K', isActive: false }
];

enum FormPlacementValue {
	Modal = 'Modal',
	Footer = 'Footer'
}

export { budgetList, BudgetValue, FormPlacementValue, navigationList, servicesList, ServiceValue };
